var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#5693F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM16 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM18 7.5H6.91L6.5 5.4A.5.5 0 0 0 6 5H4v1h1.59l1.91 9.6a.5.5 0 0 0 .5.4h9v-1H8.41L8 13h9a.5.5 0 0 0 .5-.39l1-4.5a.5.5 0 0 0-.5-.61zM16.6 12H7.81l-.7-3.5h10.265L16.6 12z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseActiveIcon);
export default __webpack_public_path__ + "static/media/purchaseActiveIcon.f5380cf4401a34889e081c591fe42f44.svg";
export { ForwardRef as ReactComponent };